import { createSimpleContext } from "@mux/ui/context"
import { ServerConnection } from "./server"

export type SyncStorage = {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

export type AsyncStorage = {
  getItem(key: string): Promise<string | null>
  setItem(key: string, value: string): Promise<unknown>
  removeItem(key: string): Promise<void>
}

export type Platform = {
  /** Platform discriminator */
  platform: "web"

  /** App version */
  version?: string

  /** Open a URL in the default browser */
  openLink(url: string): void

  /** Restart the app  */
  restart(): Promise<void>

  /** Navigate back in history */
  back(): void

  /** Navigate forward in history */
  forward(): void

  /** Send a system notification (optional deep link) */
  notify(
    title: string,
    description?: string,
    href?: string,
    options?: {
      suppressWhenViewing?: boolean
      /** The event was already visible in this page (including a child request). */
      alreadyViewed?: boolean
      id?: string
      kind?: "complete" | "error" | "permission" | "question"
      sessionID?: string
      requestID?: string
    },
  ): Promise<void>

  resolveNotification?(input: {
    kind: "permission" | "question"
    sessionID: string
    requestID: string
    machineName?: string
    href?: string
  }): Promise<void>

  /** Fetch override */
  fetch?: typeof fetch

  /** Get the configured default server URL (platform-specific) */
  getDefaultServer?(): Promise<ServerConnection.Key | null>

  /** Set the default server URL to use on app startup (platform-specific) */
  setDefaultServer?(url: ServerConnection.Key | null): Promise<void> | void
}

export const { use: usePlatform, provider: PlatformProvider } = createSimpleContext({
  name: "Platform",
  init: (props: { value: Platform }) => {
    return props.value
  },
})
